import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { stripFrontMatter } from "../../../utils/markdownHelpers";
import geoSDKWebOneFile from "../../../assets/markDownFiles/verify/SDK-Web.md";

// The ActGeo Web SDK guide. It is plain GitHub-flavoured markdown, so it only
// has its front matter removed; convertMdxToMd is not used because it strips
// `{...}` (e.g. `{ sessionId, stop }`) outside code blocks.
const GeoSdkIntegrationWeb = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    if (
      typeof geoSDKWebOneFile === "string" &&
      geoSDKWebOneFile.startsWith("/static")
    ) {
      fetch(geoSDKWebOneFile)
        .then((res) => res.text())
        .then((raw) => setContent(stripFrontMatter(raw)));
    } else {
      setContent(stripFrontMatter(geoSDKWebOneFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT Verify
      </Typography>
      {content ? <MarkdownRenderer content={content} /> : <p>Loading...</p>}
    </Box>
  );
};

export default GeoSdkIntegrationWeb;
